module.exports = __webpack_public_path__ + "img/viber image 2019-04-08 , 19.14.004.179a7a62.jpg";